export default {
  profile: 'Profile',
  company: 'Company',
  companyName: 'Company name',
  tradeName: 'Trade name',
  industry: 'Industry',
  address: 'Address',
  legalType: 'Legal type',
  legalName: 'Legal name',
  localizedTradeName: 'Localized trade name',
  merchantCategoryCode: 'Merchant Category Code',
  contacts: 'Contacts',
  phone: 'Phone',
  addContactDetails: 'Add contact details',
  accounts: 'Accounts',
  channel: 'Channel',
  value: 'Value',
  contactAdded: 'Contact added',
  // Channels
  EMAIL: 'Email',
  PHONE: 'Phone',
  WEBSITE: 'Website',
  TELEGRAM: 'Telegram',
  WECHAT: 'Wechat',
  WHATSAPP: 'Whatsapp',
};
